/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    SET_FETCH_TOURS_BY_FACILITY_STATUS,
    FETCH_TOURS_BY_FACILITY_SUCCESS,
    FETCH_TOURS_BY_FACILITY_ERROR,
    SET_TOUR_SELECTED_CARD,
} from '../actions/toursDataActions';

export const initialState = {
    loadingStatus: STATUS.IDLE,
    isLoading: true,
    error: null,
    tourList: [],
    tourMap: {},
    selectedTourId: null,
};

export const toursDataReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_TOURS_BY_FACILITY_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_TOURS_BY_FACILITY_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        }
        case FETCH_TOURS_BY_FACILITY_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        case SET_TOUR_SELECTED_CARD:
            return {
                ...state,
                selectedTourId: action.payload,
            };
        default:
            return state;
    }
};
